// A list of decorative colors we support in our systems
export var DocsBlockOptionColor;
(function (DocsBlockOptionColor) {
    DocsBlockOptionColor["green"] = "Green";
    DocsBlockOptionColor["red"] = "Red";
    DocsBlockOptionColor["yellow"] = "Yellow";
    DocsBlockOptionColor["blue"] = "Blue";
    DocsBlockOptionColor["purple"] = "Purple";
    DocsBlockOptionColor["orange"] = "Orange";
    DocsBlockOptionColor["pink"] = "Pink";
    DocsBlockOptionColor["teal"] = "Teal";
    DocsBlockOptionColor["grey"] = "Grey";
    DocsBlockOptionColor["lightGrey"] = "LightGrey";
    DocsBlockOptionColor["cyan"] = "Cyan";
    DocsBlockOptionColor["fuchsia"] = "Fuchsia";
})(DocsBlockOptionColor || (DocsBlockOptionColor = {}));
